import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import CustomerPopup from './components/CustomerPopup';
// one-time leads migration to consolidate legacy keys
import { migrateLeadsOnce } from './utils/leadsMigration';
import reportWebVitals from './reportWebVitals';
import { apiFetch } from './utils/serverConfig';

// Comprehensive MetaMask error suppression
// Suppress unhandled promise rejections from MetaMask extension
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || '';
  const stack = event.reason?.stack || '';
  
  // Suppress MetaMask connection errors from extension
  if (message.includes('MetaMask') || 
      message.includes('Failed to connect') || 
      message.includes('ethereum') ||
      stack.includes('chrome-extension://') ||
      stack.includes('inpage.js')) {
    console.debug('MetaMask connection attempt (non-blocking)');
    event.preventDefault(); // Prevent error from showing in console
    return;
  }
});

// Suppress console errors from MetaMask extension
const originalError = console.error;
console.error = (...args) => {
  const errorStr = String(args[0] || '');
  if (errorStr.includes('MetaMask') || 
      errorStr.includes('chrome-extension://') ||
      errorStr.includes('inpage.js') ||
      errorStr.includes('Failed to connect')) {
    // Completely silent - don't even warn
    return;
  }
  originalError.apply(console, args);
};

// Intercept MetaMask provider errors at window level
if (typeof window !== 'undefined' && window.ethereum) {
  const originalRequest = window.ethereum.request;
  window.ethereum.request = async function(...args) {
    try {
      return await originalRequest.apply(this, args);
    } catch (error) {
      // Silently handle connection errors
      if (error.message?.includes('connect') || error.message?.includes('MetaMask')) {
        console.debug('MetaMask request error (handled)');
        throw error; // Re-throw but it won't show as unhandled
      }
      throw error;
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const params = new URLSearchParams(window.location.search || '');
const isCustomer = params.has('customer') || params.has('mode');

root.render(
  <React.StrictMode>
    {isCustomer ? <CustomerPopup /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// run migration early (best-effort)
try {
  migrateLeadsOnce();
} catch (e) {
  // noop
}

// On app start, try to pull server orders and merge into localStorage so admin views see them
(async () => {
  try {
    const resp = await apiFetch('/api/orders');
    const json = await resp.json().catch(() => null);
    const arr = Array.isArray(json) ? json : (json && json.orders) ? json.orders : (json && json.data) ? json.data : [];
    if (!arr || !arr.length) return;
    try {
      const raw = localStorage.getItem('store_orders') || '[]';
      const cur = JSON.parse(raw);
      const merged = Array.isArray(cur) ? [...cur] : [];
      for (const o of arr) {
        try {
          const id = o.id || o.txHash || (`order_srv_${Date.now()}_${Math.random().toString(36).slice(2,6)}`);
          if (o.buyer) {
            const cand = o.buyer.from || o.buyer.contact || o.buyer.address || o.buyer.wallet || null;
            if (cand && typeof cand === 'string') o.buyer.from = cand.trim().toLowerCase();
          }
          const exists = merged.find(x => x.id === o.id || (o.txHash && x.txHash === o.txHash));
          if (!exists) {
            const toSave = { id, created: o.createdAt || new Date().toISOString(), ...o };
            merged.push(toSave);
            try { window.dispatchEvent(new CustomEvent('store:orderCreated', { detail: toSave })); } catch (e) {}
          }
        } catch (e) {}
      }
      localStorage.setItem('store_orders', JSON.stringify(merged));
    } catch (e) {}
  } catch (e) {}
})();
